module.exports = __webpack_public_path__ + "img/hr-dirt-4.2c2cc5c7.png";